module.exports = __webpack_public_path__ + "static/media/down-chevron.442fa6c7.svg";